import * as yup from "yup";

export const CheckPositionChangeSchema = yup.object({
  status: yup.boolean().required("Campo requerido"),
  reasonForRejection: yup.string().when("status", ([status], schema) => {
    return !status? schema.required("Campo requerido") : schema;
  }),
});
